import http from "../http-common";

class GetCategoryListing {
  getAllMainCategory(categoryInfo: any) {
    return http.get("/category/getCategoryWithoutFAQ", {
      params: {
        language: categoryInfo.language,
      },
    });
  }

  getLevelTwoSubCategory(categoryInfo: any) {
    return http.get("/category/getSubCategory", {
      params: {
        categoryId: categoryInfo.categoryID,
        subCategoryLevel: categoryInfo.subLevel,
        language: categoryInfo.language,
      }
    });
  }

  getAllSubCategory(categoryInfo: any) {
    return http.get("/category/getSubSubcategory", {
      params: {
        categoryId: categoryInfo.categoryID,
        subCategoryLevel: categoryInfo.subLevel,
        subSubCategoryLevel: categoryInfo.subsubLevel,
        language: categoryInfo.language,
      },
    });
  }

  bannerImage() {
    return http.get("/banner");
  }
}

export default new GetCategoryListing();
